import { CardContentType } from "../types";

type mergeCardObjectsType = {
    previousData: {front: CardContentType | null; back: CardContentType | null; merged: CardContentType | null; } | null,
    newData: CardContentType | null,
    newDataFace: "front" | "back",
}

const mergeCardObjects = ({previousData, newData, newDataFace}: mergeCardObjectsType): {front: CardContentType | null; back: CardContentType | null; merged: CardContentType | null; } | null => {
    if (!previousData && !newData) { return null; }
    if (!previousData) { previousData = {front: null, back: null, merged: null}; }
    const frontData = newDataFace === "front" ? newData : previousData.front;
    const backData  = newDataFace === "back"  ? newData : previousData.back;

    if (frontData === null) { return {front: frontData, back: backData, merged: backData}; }
    if (backData === null)  { return {front: frontData, back: backData, merged: frontData}; }

    const merged: CardContentType = {...frontData};

    for (const key in backData) {
      const typedKey = key as keyof CardContentType;
      if (!backData[typedKey]) { continue; }
      if (!merged[typedKey]) { merged[typedKey] = backData[typedKey]; }
      else {
        merged[typedKey] = [...merged[typedKey], ...backData[typedKey]];
      }

      // remove duplicates
      for (let i = merged[typedKey].length - 1; i >= 0; i--) {
        const current = merged[typedKey][i];
        const duplicateIndex = merged[typedKey].findIndex(
          (item, idx) => item.content === current.content && item.language === current.language && idx < i
        );

        if (duplicateIndex !== -1) {
          // Found duplicate, remove the current element
          merged[typedKey].splice(i, 1);
        }
      }
    }

    return {front: frontData, back: backData, merged: merged};
};

export default mergeCardObjects;